import { render, staticRenderFns } from "./cPaginator.vue?vue&type=template&id=1f1abc31&scoped=true&"
import script from "./cPaginator.vue?vue&type=script&lang=js&"
export * from "./cPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1abc31",
  null
  
)

export default component.exports